<script setup lang="ts">
import ThankYou from '@/shared/infrastructure/components/ThankYou.vue';
</script>
<template>
  <ThankYou />
</template>
